import PrintComponents from '@/components/print-components'
import { VueEditor } from "vue2-editor";
import { vueEditorToolbar } from '@/utils/constants';
import store_config from "@/store/mods/parametres/config"
import store_consultation from "@/store/mods/consultations/consultations"
import $ from 'jquery'

export default {
    name: 'examen-preview-result',
    components: {
        PrintComponents, VueEditor
    },
    props: {
        demande_examen: Object,
        evolution_id: {
            type: Number,
            default: 0
        },
        result_toggler: {
            type: Number,
            default: 0
        },
        info_resultat: {
            type: Object,
            default: () => {}
        },
        user_info: {
            type: Object,
            default: () => {}
        },
        active_role: {
            type: String,
            default: () => { return '' }
        }
    },
    data() {
        return {
            customToolbar: vueEditorToolbar,
            asset_url: '',
            result_file: '',
            can_view: true,
            file_type: false,
            is_edit_interpretation: false,
            is_edit_cliche: false,

            liste_modeles: [],
            files: [],
            selected_modele: '',
            interpretation: '',
            cliche: '',

            mdl_loading: true,
            mdl_empty: false,
            mdl_error: false,

            msg_error: "",
            save_loading: false,
            is_error: false,
            can_load_print: false
        }
    },

    watch: {
        result_toggler() {
            this.can_load_print = true
            this.$store.commit("SET_CAN_PRINT_INTERPRETATION_EXAMEN", false)
            this.$store.commit("SET_INTERPRETATION_EXAMEN_TO_PRINT", {})

            this.result_file = ''
            this.getFile()

            this.is_edit_interpretation = false
            this.is_edit_cliche = false
            this.interpretation = ''
            this.files = []
            this.msg_error = ''
            this.fetchModeleExamen()
        },

        selected_modele() {
            this.msg_error = ""
            this.autoFillCompteRendu()
        },

        interpretation() {
            this.msg_error = ""
        },

        cliche() {
            this.msg_error = ""
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        getFile() {
            if (this.demande_examen === null) {
                this.result_file = null;
            } else if (this.demande_examen.resultat === null) {
                this.asset_url = ''
                this.result_file = ''
            } else {
                this.asset_url = this.assets_path+'/files/resultats-examen'
                this.result_file = this.demande_examen.resultat
            }
            this.file_type = this.checkIfCanViewInFrame(this.result_file)
        },

        checkIfCanViewInFrame(filename) {
            let file_type = 'autre'
            if (
                filename.includes('png') || 
                filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                filename.includes('jpg') || filename.includes('JPG') 
            ) {
                file_type = 'image'
            } else if (filename.includes('pdf')) {
                file_type = 'pdf'
            }
            return file_type
        },

        printResultatExamen(data) {
            this.$store.commit("SET_CAN_PRINT_INTERPRETATION_EXAMEN", true)
            this.$store.commit("SET_INTERPRETATION_EXAMEN_TO_PRINT", data)
        },

        toggleInterpretationMode() {
            this.is_edit_interpretation = !this.is_edit_interpretation
            this.interpretation = this.info_resultat.interpretation
        },


        toggleClicheMode() {
            this.is_edit_cliche = !this.is_edit_cliche
            this.files = []
            this.cliche = ''
        },

        fetchModeleExamen() {
            this.mdl_loading = true

            const data = {
                type_examen_id: this.demande_examen.type_examen_id
            }
            store_config.getListeModeleExamens(data).then((response) => {
                this.liste_modeles = response
                if (response.length == 0) {
                    this.mdl_empty = true
                } else {
                    this.mdl_empty = false
                }
                this.mdl_loading = false
            }).catch(() => {
                this.mdl_loading = false
                this.mdl_error = true
            })
        },

        autoFillCompteRendu() {
            let content = this.selected_modele.model_field.default_value
            content = content.replace("[NOM_MEDECIN]", this.user_info.nom)
            content = content.replace("[NOM_PATIENT]", this.info_resultat.patient)
            content = content.replace("[DATE_NAISSANCE_PATIENT]", this.formatDateToDmY(this.info_resultat.date_naissance))
            content = content.replace("[AGE_PATIENT]", this.info_resultat.age)
            content = content.replace("[VILLE]", this.ville_le)
            content = content.replace("[DATE]", this.formatDateToDmY(this.info_resultat.date))
            content = content.replace("[NOM_CLINIQUE]", this.nom_clinique)

            this.interpretation = content
        },

        saveInterpretation() {
            if (this.interpretation.trim() == '') {
                this.msg_error = "Le compte rendu ne peut pas être vide !"
                return
            }

            const data = {
                bulletin_id: this.info_resultat.bulletin_id,
                demande_id: this.info_resultat.demande_id,
                type_examen_id: this.demande_examen.type_examen_id,
                interpretation: this.interpretation,
                user_id: this.user_info.id,
                user_info: this.user_info,
            }

            console.log("Save interpretation examen: ", data);

            this.save_loading = true
            store_consultation.saveExamenInterpretation(data).then((response) => {
                if (response.success) {
                    this.$refs.resultat_examen.click()
                    this.successToast(response.message)
                    this.$emit('emitRegistreExamen')
                } else {
                    this.msg_error = response.message
                }
				this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur s'est produite lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        },

        handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files;
			/*
				Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}

            this.cliche = this.files[0];
            this.clearAll()
		},

        clearAll() {
			this.is_error = false
			$('.err-msg').fadeOut(500)
			$('.err-fsize').fadeOut(500)
			$('.err-extension').fadeOut(500)
		},

        saveCliche() {
            if (this.cliche == '' || this.cliche === null) {
                this.msg_error = "Veuillez choisir un fichier à envoyer !"
                return;
            }

            let max_file_size = 5120
            if (!this.fileValidation(max_file_size, 'files')) {
                return;
            }

            console.log("Save cliche: ", this.cliche);
            const data = {
                bulletin_id: this.info_resultat.bulletin_id,
                demande_id: this.info_resultat.demande_id,
                type_examen_id: this.demande_examen.type_examen_id,
                user_id: this.user_info.id,
                user_info: this.user_info,
                cliche: this.cliche
            }

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            this.save_loading = true
            store_consultation.saveClicheExamen(form_data).then((response) => {
                if (response.success) {
                    this.$refs.resultat_examen.click()
                    this.successToast(response.message)
                    this.$emit('emitRegistreExamen')
                } else {
                    this.msg_error = response.message
                }
				this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur s'est produite lors de l'enregistrement. Veuillez réessayer plus tard."
            })
        }
    }
}


